import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

class ProfileStore extends ReduceStore {
  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.PROFILE_LOADED:
        return action.profile;
      default:
        return state;
    }
  }


  getGivenName() {
    return this.getState() && this.getState().given_name;
  }

}

const instance = new ProfileStore(AppDispatcher);
export default instance;
